import { gql, useQuery } from "@apollo/client";

export const CHECK_PENALTY_DSP_IMPORT_GRAY = gql`
  query CheckPenaltyDspImportGray($warehouseId: Long) {
    checkPenaltyDspImportGray(warehouseId: $warehouseId)
  }
`;

interface CheckPenaltyDspImportGrayResponse {
  checkPenaltyDspImportGray: boolean;
}

/**
 * 「罚单管理中心」菜单灰度，两侧共用一个后端接口，但判定口径不同，二选一、不能混用：
 * - warehouseId（只有 WMS 侧才传）：由该仓经 warehouse_dsp 查出关联 DSP，**任一**命中白名单即为 true
 * - byLoginDsp（DSP 侧）：后端从登录态取 DSP，只看**登录 DSP 自己**是否命中白名单
 *
 * DSP 页面即使手头有 warehouseId（如 DeliveryLayout 的仓库选择器）也禁止传：
 * warehouse_dsp 是多对多，按仓判定会让同仓其它 DSP 的灰度「传染」给未灰度的 DSP，菜单错误展示。
 * 下面的联合类型把这条约束交给编译期，两个参数同时传会直接报错。
 *
 * 配置键固定在后端（partner_penalty.dsp_import_whitelist），前端不传。
 * 查询失败时 data 为空，isInGrayConfig 退化为 false，即隐藏菜单。
 */
type CheckPenaltyDspImportGrayOptions =
  | { warehouseId?: string; byLoginDsp?: never }
  | { byLoginDsp: boolean; warehouseId?: never };

export const useCheckPenaltyDspImportGray = (
  options: CheckPenaltyDspImportGrayOptions = {}
) => {
  const { warehouseId, byLoginDsp = false } = options;
  const { data, loading, error, refetch } = useQuery<CheckPenaltyDspImportGrayResponse>(
    CHECK_PENALTY_DSP_IMPORT_GRAY,
    {
      variables: {
        warehouseId: warehouseId ? parseInt(warehouseId, 10) : null
      },
      // 按仓模式要等仓选定；按登录 DSP 模式不需要仓，由调用方用菜单权限决定是否开启
      skip: byLoginDsp ? false : !warehouseId,
      fetchPolicy: 'network-only'
    }
  );

  return {
    isInGrayConfig: data?.checkPenaltyDspImportGray ?? false,
    loading,
    error,
    refetch
  };
};
